import { generateClient } from 'aws-amplify/api';
import axios from 'axios';
import { requestAPIClient, requestOTPClient, requestSSOClient } from '../../Networking/clients';

const GRAPHQL_ENDPOINT = 'https://h5d7cqtrjnhw7mc7pktq467y6q.appsync-api.us-east-1.amazonaws.com/graphql';
// const GRAPHQL_ENDPOINT = 'https://ztod4ik4mrgqpj5v4k4ypr6yl4.appsync-api.us-east-1.amazonaws.com/graphql';

export const getSignedInUser = () => {
    const accessToken = sessionStorage.getItem('accessToken');
    const idToken = sessionStorage.getItem('idToken');
    const email = sessionStorage.getItem('email');
    const first_name = sessionStorage.getItem('first_name');
    const last_name = sessionStorage.getItem('last_name');
    return { accessToken, idToken, email, first_name, last_name };
};

export const isUserSignedIn = () => {
    const user = getSignedInUser();
    if (user.accessToken && user.idToken && user.email) {
        return true;
    }
    return false;
};
//Fetch products by category or ALL
export const retrieveProducts = async (categoryID) => {
    const query = categoryID
        ? `query {
        publicProducts(filter: {category_id: "${categoryID}"}) {
            id
            name
            description
            thumbnail
            vendor {
            id
            company_name
            }
            categories {
            id
            }
            }
        }`
        : `query {
        publicProducts(filter: {}) {
            id
            name
            description
            thumbnail
            categories {
            id
            }
        }
        }`;

    try {
        // Use the pre-configured requestClient
        const response = await requestAPIClient.post(
            '',
            { query }  // Send the query as part of the POST request body
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.publicProducts;  // Return the products from the response

    } catch (error) {
        console.error('Error fetching vendor listings:', error);
        throw error;
    }
};

//Fetching detailed product information
export const fetchProductDetails = async (productID) => {
    const query = `
        query MyQuery {
            publicProducts(filter: {id: "${productID}"}) {
            id
            description
            categories {
                id
            }
            features
            website
            banner
            contact_email
            facebook
            has_free_trial
            has_free_version
            images
            instagram
            linkedin
            name
            pricing
            thumbnail
            twitter
            vendor {
                id
                company_name
                year_founded
                vendor_bio
                website
            }
            videos
            }
        }`;

    try {
        const response = await requestAPIClient.post(
            '',
            { query }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.publicProducts;
    } catch (error) {
        console.error('Error fetching vendor listings:', error);
        throw error;
    }
}

// Sending OTP to email during placing an order
export const sendOTP = async (email) => {
    if (!email) {
        throw new Error('Email is required');
    }

    try {
        const response = await requestOTPClient.post( 
            '',
            {
                
                email: email,
            }
        );
        return response.data;
    }
    catch (error) {
        throw new Error('Error sending OTP:', error);
    }
};

//Creating orders function for non SSO logged in user
export const otpCreateOrder = async (name, email, otp, practiceName, message, productId) => {
    const mutation = `
        mutation MyMutation {
            createOrder(input: {
            practice_user_name: "${name}", 
            practice_user_email: "${email}",
            product_id: "${productId}",
            practice_name: "${practiceName}",
            message: "${message}",
            is_charmhealth_user: false
            }) 
            {
                id
            }
        }
        `;

    try {
        const response = await requestSSOClient('emailVerify', null, email, otp).post(
            '',
            {
                query: mutation
            }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.createOrder.id;
    }
    catch (error) {
        console.error('Error creating order:', error);
        return null;
    }
}

//Creating orders function for SSO logged in user
export const ssoCreateOrder = async (practiceName, message, productId) => {
    const user = getSignedInUser();
    const mutation = `
        mutation MyMutation {
            createOrder(input: {
            practice_name: "${practiceName}",
            message: "${message}",
            product_id: "${productId}",
            is_charmhealth_user: true
            }) {
            id
            }
        }
        `;

    try {
        const response = await requestSSOClient('sso', user.idToken, null, null).post(
            '',
            {
                query: mutation
            }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.createOrder.id;
    }
    catch (error) {
        console.error('Error creating order:', error);
        return null;
    }
}

// Fetch reviews for a product
export const fetchReviews = async (productId) => {
    const query = `
        query {
            reviews(filter: {product_id: "${productId}"}) {
                id
                practice_user_name
                rating
                comment
                created_at
                vendor_response
            }
        }
    `;

    try {
        const result = await requestAPIClient.post(
            '',
            { query }
        );
        return result.data.data.reviews;
    } catch (error) {
        console.error('Error fetching vendor listings:', error);
        throw error;
    }
}

export const createReview = async (productId, vendorId, rating, comment) => {
    const user = getSignedInUser();
    const mutation = `
        mutation {
            createReview(input: {
                product_id: "${productId}",
                rating: ${rating},
                comment: "${comment}",
            }) {
                id
            }
        }
    `;

    try {
        const response = await requestSSOClient('sso', user.idToken, null, null).post(
            '',
            {
                query: mutation
            }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.createReview.id;
    }
    catch (error) {
        console.error('Error creating review:', error); 
        return null;
    }
}


// Function to fetch order details for the user (practice) by email
export const fetchOrders = async () => {
    const user = getSignedInUser();
    // GraphQL query to fetch orders with id, product_name, and status
    const query = `
            query GetUserOrders {
                orders(filter: {practice_user_email: "${user.email}"}) {
                    id
                    product {
                        name
                    }
                    status
                    vendor {
                        company_name
                    }
                }
            }
        `;

    try {
        const response = await requestSSOClient('sso', user.idToken, null, null).post(
            '',
            {
                query: query
            }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.orders;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};

// Function to fetch messages for the selected order
export const fetchMessages = async (orderId) => {

    const user = getSignedInUser();
    const query = `
    query orderMessages {
        orderMessages(filter: { order_id: "${orderId}" }) {
            id
            attachment
            message
            created_at
            order_id
            recipient
            sender
            updated_at
        }
    }
`;

    try {
        const response = await requestSSOClient('sso', user.idToken, null, null).post(
            '',
            {
                query: query
            }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.orderMessages;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};

export const sendMessage = async (orderId, newMessage) => {
    if (!newMessage.trim()) {
        return; // Don't send empty messages without attachment
    }

    const user = getSignedInUser();
    const mutation = `
    mutation createOrderMessage {
        createOrderMessage(input: {
            order_id: "${orderId}",
            message: "${newMessage}",
            attachment: ""
        }) {
            id
            attachment
            message
            created_at
            order_id
            recipient
            sender
            updated_at
        }
    }
`;

    try {
        const response = await requestSSOClient('sso', user.idToken, null, null).post(
            '',
            {
                query: mutation
            }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.createOrderMessage;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};

export const updateOrderStatus = async (orderId, status) => {

    const user = getSignedInUser();

    // GraphQL mutation to update the order's status
    const mutation = `
        mutation UpdateOrderStatus {
            updateOrderStatus(input: {
                id: ${orderId},
                status: "${status}" 
            }) {
                id
                status
            }
        }
    `;

    try {
        const response = await requestSSOClient('sso', user.idToken, null, null).post(
            '',
            {
                query: mutation
            }
        );

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data.data.updateOrderStatus;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}